




































import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Component } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import AsignacionFiltroPlataforma from '@/components/Asignaciones/AsignacionFiltroPlataforma.vue';
import AsignacionBusqueda from '@/components/Asignaciones/AsignacionBusqueda.vue';
import AsignacionPersonal from '@/components/Asignaciones/AsignacionPersonal.vue';
import GridResumen from '@/components/Asignaciones/GridResumen.vue';
import TabGridSeleccion from '@/components/Asignaciones/TabGridSeleccion.vue';
import GridPatentes from '@/components/Asignaciones/GridPatentes.vue';
import AsociarVehiculos from '@/reusable/AsociarFlotaEtiquetaVehiculo/AsociarVehiculos.vue';
import store from '@/store';
import GridSeleccion from '@/components/Asignaciones/GridSeleccion.vue';
import { asociacionEventBus } from '@/setup';

@Component({
  components: {
    AsignacionFiltroPlataforma,
    AsignacionBusqueda,
    AsignacionPersonal,
    GridResumen,
    GridSeleccion,
    GridPatentes,
    AsociarVehiculos,
    TabGridSeleccion,
  },
})
export default class Asignaciones extends ComponenteBase {
  constructor() {
    super();
  }

  seleccion: number = 0;

  readonly funcionalidad: Funcionalidades =
    Funcionalidades.AsignacionTransportista;

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionCrear];
  mounted() {
    asociacionEventBus.$on('asignacionReady', (asignacion: any) => {
      console.log(asignacion);
      const refPlataforma = this.$refs.asignacionPlataforma as any;
      const refTransportista = this.$refs.asignacionPersonal as any;
      const refBusqueda = this.$refs.asignacionBusqueda as any;
      const refGridSeleccion = this.$refs.asignacionSeleccion as any;
      asociacionEventBus.$emit('resetGrillas');
      refPlataforma.reset();
      refBusqueda.reset();
      refTransportista.reset();
      refGridSeleccion.reset();
      if (asignacion)
        this.$snotify.success(
          this.$t('mensajes.mensajesAsociacionesExito.editarMasivo')
        );
    });
  }
}
